var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPersonCircle = function SvgPersonCircle(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.166748C6.38333 0.166748 7.5 1.28341 7.5 2.66675C7.5 4.05008 6.38333 5.16675 5 5.16675C3.61667 5.16675 2.5 4.05008 2.5 2.66675C2.5 1.28341 3.61667 0.166748 5 0.166748ZM5 12.0001C2.91667 12.0001 1.075 10.9334 0 9.31675C0.025 7.65841 3.33333 6.75008 5 6.75008C6.65833 6.75008 9.975 7.65841 10 9.31675C8.925 10.9334 7.08333 12.0001 5 12.0001Z",
    fill: "#130E3A"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPersonCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/person_circle.6434caa38f87ecd7ae2aed21ce8e5d6f.svg";